import { NgModule } from '@angular/core';
import { PreloadAllModules, RouterModule, Routes } from '@angular/router';

const routes: Routes = [
  {
    path: '',
    redirectTo: 'splash',
    pathMatch: 'full'
  },
  /*{
    path: 'home',
    loadChildren: () => import('./home/home.module').then(m => m.HomePageModule)
  },
  {
    path: 'list',
    loadChildren: () => import('./list/list.module').then(m => m.ListPageModule)
  },*/
  { path: 'splash', loadChildren: './splash/splash.module#SplashPageModule' },
  { path: 'swiper', loadChildren: './swiper/swiper.module#SwiperPageModule' },
  { path: 'login', loadChildren: './login/login.module#LoginPageModule' },
  { path: 'create-account', loadChildren: './create-account/create-account.module#CreateAccountPageModule' },
  { path: 'forgot-password', loadChildren: './forgot-password/forgot-password.module#ForgotPasswordPageModule' },
  { path: 'restaurants', loadChildren: './restaurants/restaurants.module#RestaurantsPageModule' },
  { path: 'account', loadChildren: './account/account.module#AccountPageModule' },
  { path: 'support', loadChildren: './support/support.module#SupportPageModule' },
  { path: 'myorder', loadChildren: './myorder/myorder.module#MyorderPageModule' },
  { path: 'filter', loadChildren: './filter/filter.module#FilterPageModule' },
  { path: 'track-order', loadChildren: './track-order/track-order.module#TrackOrderPageModule' },
  { path: 'empty', loadChildren: './empty/empty.module#EmptyPageModule' },
  { path: 'offer', loadChildren: './offer/offer.module#OfferPageModule' },
  { path: 'restaurantslist', loadChildren: './restaurantslist/restaurantslist.module#RestaurantslistPageModule' },
  { path: 'checkout', loadChildren: './checkout/checkout.module#CheckoutPageModule' },
  { path: 'new-restaurant', loadChildren: './new-restaurant/new-restaurant.module#NewRestaurantPageModule' },
  { path: 'popularchoice', loadChildren: './popularchoice/popularchoice.module#PopularchoicePageModule' },
  { path: 'map', loadChildren: './map/map.module#MapPageModule' },
  { path: 'chat', loadChildren: './chat/chat.module#ChatPageModule' },
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, { preloadingStrategy: PreloadAllModules })
  ],
  exports: [RouterModule]
})
export class AppRoutingModule {}
